import React from 'react';

export default function AveMaria() {
  return (
    <>
        <p>
        Dios te salve María <br/> llena eres de gracia <br/> el Señor es contigo; <br/> bendita tú eres entre todas las mujeres, <br/> y bendito es el fruto de tu vientre, Jesús. <br/> <br/> Santa María, Madre de Dios, <br/> ruega por nosotros, pecadores, <br/> ahora y en la ahora de nuestra muerte. <br/> <br/> Amén.
        </p>
    </>
  );
}
